import { useGet } from '../../HttpClient';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { AccountTreatmentIndicatorModel } from '../../../models/referenceDataModels';

export function useAccountAvailableTreatmentIndicators(accountId: string) {
  const get = useGet(true, "ams");
  const getAccountAvailableTreatmentIndicators = (accountId: string): Promise<AccountTreatmentIndicatorModel[]> =>
      get(`/api/proxy/ams/account-service/account/${accountId}/available-treatment-indicators`);
  return useQueryWithErrorHandling({
    queryKey: ['get-account-available-treatment-indicators', accountId],
    enabled: !!accountId,
    queryFn: async () => await getAccountAvailableTreatmentIndicators(accountId),
  });
}

